import React from 'react';
import { Chart, Axis, Tooltip, Geom } from 'bizcharts';
import autoHeight from '../autoHeight';
import '../index.less';
class MiniArea extends React.Component {
    render() {
        const { height, data = [], forceFit = true, color = 'rgba(24, 144, 255, 0.2)', borderColor = '#1089ff', scale = {}, borderWidth = 2, line, xAxis, yAxis, animate = true, } = this.props;
        const padding = [36, 5, 30, 5];
        const scaleProps = {
            x: Object.assign({ type: 'cat', range: [0, 1] }, scale.x),
            y: Object.assign({ min: 0 }, scale.y),
        };
        const tooltip = [
            'x*y',
            (x, y) => ({
                name: x,
                value: y,
            }),
        ];
        const chartHeight = height + 54;
        return (React.createElement("div", { className: "miniChart", style: { height } },
            React.createElement("div", { className: "chartContent" }, height > 0 && (React.createElement(Chart, { animate: animate, scale: scaleProps, height: chartHeight, forceFit: forceFit, data: data, padding: padding },
                React.createElement(Axis, Object.assign({ key: "axis-x", name: "x", label: undefined }, xAxis)),
                React.createElement(Axis, Object.assign({ key: "axis-y", name: "y" }, yAxis)),
                React.createElement(Tooltip, { showTitle: false, crosshairs: false }),
                React.createElement(Geom, { type: "area", position: "x*y", color: color, tooltip: tooltip, shape: "smooth", style: {
                        fillOpacity: 1,
                    } }),
                line ? (React.createElement(Geom, { type: "line", position: "x*y", shape: "smooth", color: borderColor, size: borderWidth, tooltip: false })) : (React.createElement("span", { style: { display: 'none' } })))))));
    }
}
export default autoHeight()(MiniArea);
